/**
 * ARIA Header Component
 * Version: 1.0.0
 */

import { Bell, MessageSquare } from 'lucide-react';
import { useState } from 'react';
import { ChatInterface } from '../ChatInterface';

export function Header() {
  const [showChat, setShowChat] = useState(false);

  return (
    <>
      <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-6">
        <div className="flex items-center gap-4">
          <h2 className="text-lg font-semibold text-gray-900">All Weather Windows</h2>
        </div>

        <div className="flex items-center gap-3">
          <button
            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
            title="Notifications"
          >
            <Bell className="w-5 h-5" />
          </button>

          <button
            onClick={() => setShowChat(!showChat)}
            className={`p-2 rounded-lg transition-colors ${
              showChat
                ? 'text-brand-600 bg-brand-50'
                : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'
            }`}
            title="ARIA Assistant"
          >
            <MessageSquare className="w-5 h-5" />
          </button>
        </div>
      </header>

      {/* Chat sidebar */}
      {showChat && (
        <div className="fixed right-0 top-16 bottom-0 w-96 bg-white border-l border-gray-200 shadow-lg z-50">
          <ChatInterface onClose={() => setShowChat(false)} />
        </div>
      )}
    </>
  );
}
